export default {
  methods: {
    /**
     * Adiciona a máscara para transações da CMB
     * @param {String} etiqueta
     * @return {String}
     */
    mascaraTransacao(etiqueta) {
      return etiqueta.replace(/(.{4})/g, "$1-");
    },
    /**
     * Tira a máscara de transações da CMB
     * @param {String} etiqueta
     * @return {String}
     */
    tirarMascaraTransacao(etiqueta) {
      return etiqueta.replace(/-/g, "");
    },
    /**
     * Aceita uma série de textos, deixando apenas o primeiro caractere de cada texto maiúsculo
     * @param {String} str
     * @return {String}
     */
    letraMaiusculaCadaPalavra(str) {
      if (["", null, undefined].includes(str)) return "";
      let splitStr = str.toLowerCase().split(" ");
      for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = this.primeiraLetraMaiuscula(splitStr[i]);
      }
      return splitStr.join(" ");
    },
    /**
     * Deixa apenas o primeiro caractere maiúsculo
     * @param {String} texto
     * @return {String}
     */
    primeiraLetraMaiuscula(texto) {
      return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
    },
    /**
     * Adiciona zeros à esquerda
     * @param {String} str
     * @param {Number} max
     * @return {String}
     */
    zeroEsquerda(str, max = 3) {
      str = str.toString();
      return str.length < max ? this.zeroEsquerda("0" + str, max) : str;
    },
    /**
     * Serve para pegar o nome da unimed em textos no formato "codigoUnimed - nomeUnimed" e retorna apenas "nomeUnimed"
     * @param {String} textoExibicao
     * @return {String}
     */
    pegaNomeTextoExibicao(textoExibicao) {
      return textoExibicao.substring(textoExibicao.indexOf("-") + 1);
    },
    /**
     * Máscara para telefone no formato: (##) #####-#### ou (##) ####-####
     * @param {String} telefone
     * @return {String}
     */
    mascaraTelefone(telefone) {
      if ([null, undefined].includes(telefone)) return "";

      let t = telefone;
      t = t.replace(/^(\d{2})(\d{5}|\d{4})(\d{4}).*/, "($1) $2-$3");
      return t;
    },
    /**
     * Máscara para telefone no formato 0800: (##) ####-#######
     * @param {String} telefone
     * @return {String}
     */
    mascaraTelefone0800(telefone) {
      if ([null, undefined].includes(telefone)) return "";

      let t = telefone;
      t = t.replace(/^(\d{2})(\d{4})(\d{7}).*/, "($1) $2-$3");
      return t;
    },
    /**
     * Retira a máscara para telefone
     * @param {String} telefone
     * @return {String}
     */
    tirarMascaraTelefone(telefone) {
      let t = telefone;
      t = t.replace(/\D/g, "");
      return t;
    },
    /**
     * Converte bytes para o tamanho correto do arquivo
     * @param { Number } bytes
     * @param { Number } decimals
     * @return { String }
     */
    formatarBytes(bytes, decimals) {
      if (bytes == 0) return "0 Bytes";
      var k = 1024,
        dm = decimals <= 0 ? 0 : decimals || 2,
        sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    /**
     * Adiciona uma máscara de cep para uma string
     * @param {String} cep
     * @return {String}
     */
    mascaraCep(cep) {
      if (cep.length !== 8) return cep;

      let c = cep;
      c = c.replace(/^(\d{5})(\d{3}).*/, "$1-$2");
      return c;
    }
  }
};
